<template>
  <section>
    <div
        :style="{ 'background-image': `url(${imageBackgroundSrc})` }"
      class="md-max:mt-0 relative bg-cover relative bg-bottom bg-no-repeat "
    >
      <div class="md-max:bg-white md-max:opacity-80">
        <div class="px-14 sm-max:px-5">
          <h2
              class="lg:text-38 md:text-28 sm-max:px-2 text-2xl text-center sm-max:text-2xl z-[1] relative lg:mb-5"
          >
            <strong v-html=" title "></strong>
          </h2>

          <div
              class="text-left lg:leading-7 sm-max:text-base z-[1] relative md-max:pb-14 space-y-5 b-5 pb-80 lg:text-21 md:text-base text-15 lg:pr-10"
          >
            <div class="lg:!mt-10" v-html=" paragraph1"></div>

            <div class="max-w-xl lg:leading-8">
              <div v-html=" paragraph2"></div>
              <div class="!mt-3" v-html=" paragraph3"></div>
              <div class="!mt-3" v-html=" paragraph4"></div>
              <div class="!mt-3" v-html=" paragraph5"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-14 px-16 md-max:mt-10 sm-max:px-5">
      <div class="grid gap-8 md:grid-cols-2">
        <div class="col-span-1 space-y-5 md-max:col-span-2 text-21 lg:pr-6">
          <div class="lg:leading-30 leading-5 md-max:text-15" v-html="offerText">


          </div>

          <div class="lg:text-21 md:text-lg text-15" v-html="newCustomersText"></div>
          <div class="lg:text-21 md:text-lg text-15 !mt-5" v-html="loveCoffeeText1"></div>
          <div class="lg:text-21 md:text-lg text-15 !mt-5" v-html="loveCoffeeText2"></div>
        </div>

        <div class="col-span-1 md-max:col-span-2">
          <nuxt-img
              class="m-auto lg:-mt-7 md-max:ml-0"
              width="520"
              height="409"
              loading="lazy"
              :alt="productImageAlt"
              format="webp"
              sizes="sm:400px md:100vw lg:100vw xl:520px"
              :src="productImageSrc"
          ></nuxt-img>

<!--          <div id="the-products"></div>-->
        </div>
      </div>
    </div>


<!--    <Swatches/>-->
  </section>
</template>
<script setup>
// import Swatches from "./Swatches.vue"

const props = defineProps({
  imageBackgroundSrc: {
    type: String,
    default: '/assets/images/freebag-sect6-bg.jpg'
  },
  title: {
    type: String,
    default: 'From My House to Yours: Lifeboost Coffee'
  },
  paragraph1: {
    type: String,
    default: 'Now I’m able to drink coffee guilt-free. It tastes delicious and is free of all those harmful chemicals, additives, and pesticides in so many brands found in stores and coffee shops.'
  },
  paragraph2: {
    type: String,
    default: 'This great-tasting, pure coffee is Lifeboost.'
  },
  paragraph3: {
    type: String,
    default: 'I know this may be your first time as a Lifeboost customer. This is likely your first time trying a coffee so pure, clean, and delicious.'
  },
  paragraph4: {
    type: String,
    default: 'So I have a deal for you.'
  },
  paragraph5: {
    type: String,
    default: 'I know you’re going to love this coffee. After one try, you’ll never go back to mass-produced toxin-loaded “generic” coffee.'
  },
  offerText: {
    type: String,
    default: 'Today you can get full 12 ounce bags of Lifeboost Coffee, large enough for 40 cups each, for 50% off!'
  },
  newCustomersText: {
    type: String,
    default: 'This is for new customers only. Limit one per household.'
  },
  loveCoffeeText1: {
    type: String,
    default: 'You’re going to love this coffee.'
  },
  loveCoffeeText2: {
    type: String,
    default: 'I can’t wait to hear about your experience.'
  },
  productImageAlt: {
    type: String,
    default: '50% off'
  },
  productImageSrc: {
    type: String,
    default: '/assets/images/lifeboost-50-per.png'
  }
})


defineBuilderComponent({
    friendlyName: "FromMyHouse-2",
    canHaveChildren: true,
    inputs: [
        {
            name: "imageBackgroundSrc",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "png",
                "svg"
            ],
            defaultValue: "/assets/images/freebag-sect6-bg.jpg"
        },
        {
            name: "title",
            type: "richText",
            defaultValue: "From My House to Yours: Lifeboost Coffee"
        },
        {
            name: "paragraph1",
            type: "richText",
            defaultValue: "Now I’m able to drink coffee guilt-free. It tastes delicious and is free of all those harmful chemicals, additives, and pesticides in so many brands found in stores and coffee shops."
        },
        {
            name: "paragraph2",
            type: "richText",
            defaultValue: "This great-tasting, pure coffee is Lifeboost."
        },
        {
            name: "paragraph3",
            type: "richText",
            defaultValue: "I know this may be your first time as a Lifeboost customer. This is likely your first time trying a coffee so pure, clean, and delicious."
        },
        {
            name: "paragraph4",
            type: "richText",
            defaultValue: "So I have a deal for you."
        },
        {
            name: "paragraph5",
            type: "richText",
            defaultValue: "I know you’re going to love this coffee. After one try, you’ll never go back to mass-produced toxin-loaded “generic” coffee."
        },
        {
            name: "offerText",
            type: "richText",
            defaultValue: "Today you can get full 12 ounce bags of Lifeboost Coffee, large enough for 40 cups each, for 50% off!"
        },
        {
            name: "newCustomersText",
            type: "richText",
            defaultValue: "This is for new customers only. Limit one per household."
        },
        {
            name: "loveCoffeeText1",
            type: "richText",
            defaultValue: "You’re going to love this coffee."
        },
        {
            name: "loveCoffeeText2",
            type: "richText",
            defaultValue: "I can’t wait to hear about your experience."
        },
        {
            name: "productImageAlt",
            type: "string",
            defaultValue: "50% off"
        },
        {
            name: "productImageSrc",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "png",
                "svg"
            ],
            defaultValue: "/assets/images/lifeboost-50-per.png"
        }
    ]
});
</script>
